import { useModal } from 'components/modals';

export function useShowTagsModal() {
  const { showModal } = useModal();

  return () => {
    showModal('TAGS_MODAL', { size: 1100 });
  };
}
